<template>
  <div class="mt-24">
    <div class="el-card p-16 params-item">

      <el-cascader v-model="areaValue" ref="areaDropdown" class="fx-none" placeholder="全国" :show-all-levels="false" clearable :options="selectArea" collapse-tags
        :props="{multiple:true,children:'childOption',checkStrictly:false,emitPath:false}" />

      <el-date-picker v-model="time" ref="dataPicker" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
        :picker-options="pickerOptions" :clearable="false" style="width: 280px;">
      </el-date-picker>
      <!-- <TreeDropdown v-model="value2" placeholder="请选择事件" multiple collapseTags showCheckbox checkStrictly nodeKey="id" :data="treeData" /> -->
      <!-- <el-input v-model="keywordList" placeholder="请选输入公司名称" size="large" style="width: 200px;"></el-input> -->
      <!-- <el-select v-model="keywordList" multiple filterable clearable default-first-option placeholder="请选输入搜索关键词">
        <el-option v-for="item in keywordOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
      <el-select v-model="keywordList" filterable multiple clearable placeholder="请输入搜索关键词" remote :remote-method="remoteMethod2">
        <el-option v-for="item in keywordOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-select v-model="organizationVal" filterable clearable placeholder="请输入机构名称" remote :remote-method="remoteMethod">
        <el-option v-for="item in organizationOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-select v-model="policyType" filterable multiple clearable placeholder="请输入政策类型">
        <el-option v-for="item in policyOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <!-- <el-input v-model="selectedLabel" placeholder="请选输入机构名称" size="large" style="width: 200px;"></el-input> -->

      <el-button class="mr-16 mb-16" @click="resetHandle">重置</el-button>
      <el-button class="ml-0 mb-16" type="primary" @click="searchHandle">查询</el-button>
    </div>

    <div class="fx mt-24 pb-16">
      <div class="el-card fx-full p-16">
        <div class="fx mb-16">
          <div class="fx-full"></div>
          <el-radio-group v-model="radio1" class="fx-none" size="mini" @change="radioHandle">
            <el-radio-button label="1">匹配度顺序</el-radio-button>
            <el-radio-button label="2">按时间排序</el-radio-button>
          </el-radio-group>
        </div>

        <div class="fx-full el-card pl-16">
          <el-scrollbar ref="scrollbar" wrap-class="scrollbar-wrapper scrollbar-wrapper-maxheight" style="height:684px;">
            <div class="mr-16" v-infinite-scroll="load" infinite-scroll-disabled="disabled" :key="scrollKey">
              <TextDocument v-for="(item,i) in policyList" :data="item" :key="i" :showTag="true" />
              <p v-if="loading" class="textAline">加载中...</p>
              <p v-if="policyList.length && noMore" class="textAline">- 没有更多了 -</p>
            </div>
            <EmptyBox v-if="!policyList.length&&!loading" />
          </el-scrollbar>
        </div>
      </div>
      <div class="ml-24 fx-none" style="width: 500px;">
        <div class="el-card p-16 mb-24">
          <MyTitle class="mb-16">
            政策高频词
          </MyTitle>
          <div>
            <el-table :data="tableData" style="width: 100%" max-height="300">
              <el-table-column prop="name" label="政策高频词" width="180">
              </el-table-column>
              <el-table-column prop="name" label="相关政策数量">
                <template slot-scope="{row}">
                  <el-progress :percentage="row.percentage" :format="p=>format(row)" :stroke-width="8" color="#186bfc"></el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="el-card p-16">
          <MyTitle class="mb-16">
            政策区域分布
          </MyTitle>

          <MyEcharts ref="chartFirst" style="width: 100%;height:300px;" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
function getDefaultTime() {
  const now = new Date()
  return [moment(now.getTime() - 3600 * 1000 * 24 * 90).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
}
import MyTitle from '@/views/industryChainNew/components/myTitle'
import TextDocument from '@/views/industryChainNew/components/textDocument'
import NewsDocument from '@/views/industryChainNew/components/newsDocument'
import TreeDropdown from '@/components/treeDropdown/treeDropdown.vue'
import { smallPieChart } from '../components/echartsOptions'
import MyEcharts from '@/components/myEcharts'
import keywords from '@/views/industryChainNew/markData/keywords'
import { getPolicyChain, getPolicyStat, getPolicyType, getPolicyDept, getPolicyKeyword } from '@/views/industryChainNew/api'
import chain from '@/views/industryChainNew/markData/chain'
import { mapState } from 'vuex'
export default {
  name: 'IndustryPolicy',
  components: {
    TextDocument,
    TreeDropdown,
    NewsDocument,
    MyTitle,
    MyEcharts
  },
  props: {

  },
  computed: {
    ...mapState({
      selectArea: state => state.asyncRoute.selectArea,
    }),
    ID() {
      return this.$route?.query?.id
    },
    noMore() {
      return this.total <= this.policyList.length
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  data() {
    return {
      radio1: '1',
      value: '',
      value2: '',
      selectedLabel: '',
      tableData: [],
      treeData: [],
      time: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      policyList: [],
      areaValue: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      scrollKey: 0,
      keywordList: [],
      keywordOptions: [],

      organizationVal: '',
      organizationOptions: [],

      policyType: [],
      policyOptions: [],

      cityParams: []
    }
  },
  mounted() {
    this.time = getDefaultTime()

    this.getPolicyStat()
    this.getPolicy()

    this.getPolicyType()
  },
  methods: {
    getCityParams() {
      const newNodes = this.$refs.areaDropdown.getCheckedNodes()
      const lv = [
        [], [], []
      ]
      const cityParams = []

      newNodes.forEach(e => {
        lv[e.level - 1].push(e)
      })

      function delFn(index = 0, children) {
        const idx = index + 1
        if (children) {
          lv[index] = lv[index].filter(e => {
            if (children.some(c => c.value == e.value)) {
              idx < 3 && delFn(idx, e.children)
              return false
            }
            return true
          })
        }
      }
      function getLevelHigh(index = 0) {
        const idx = index + 1
        lv[index].forEach(e => {
          cityParams.push(e)
          idx < 3 && delFn(idx, e.children)
        })
        idx < 3 && getLevelHigh(idx)
      }
      getLevelHigh()
      this.cityParams = cityParams
      return cityParams
    },
    format(row) {
      return row.count
    },

    initCharts(regionStat) {
      this.$refs.chartFirst.update(smallPieChart(regionStat))
    },

    async getPolicyType() {
      const [err, res] = await this.$reqFn(getPolicyType)
      if (err) console.log(err)
      if (res && res.code === 200) {
        this.policyOptions = res.data || []
      }
    },

    remoteMethod(query) {
      if (query !== '') {
        this.getPolicyDept(query)
      } else {
        this.organizationOptions = []
      }
    },
    async getPolicyDept(query) {
      const [err, res] = await this.$reqFn(getPolicyDept, { keyword: query })
      // const [err, res] = await this.$reqFn(getPolicyDept, { keyword: this.organizationVal })
      if (err) console.log(err)
      if (res && res.code === 200) {
        this.organizationOptions = res.data || []
      }
    },
    remoteMethod2(query) {
      if (query !== '') {
        this.getPolicyKeyword(query)
      } else {
        this.keywordOptions = []
      }
    },

    async getPolicyKeyword(query) {
      const [err, res] = await this.$reqFn(getPolicyKeyword, { keyword: query, secId: this.ID })
      if (err) console.log(err)
      if (res && res.code === 200) {
        this.keywordOptions = res.data || []
      }
    },

    async getPolicyStat() {
      const params = {
        areaCode: this.cityParams.length ? this.cityParams.map(e => e.value) : undefined,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        secId: this.ID,
        startDate: this.time[0],
        endDate: this.time[1],
      }

      const [err, res] = await this.$reqFn(getPolicyStat, params)
      if (err) console.log(err)
      if (res && res.code === 200) {
        const { keywordList, regionStat } = res.data // keywords
        this.tableData = keywordList?.map(e => {
          return { ...e, percentage: e.count / keywordList[0].count * 100 }
        })
        this.initCharts(regionStat || [])
      }
    },
    load() {
      this.getPolicy()
    },
    async getPolicy() {
      const params = {
        areaCode: this.cityParams.length ? this.cityParams.map(e => e.value) : undefined,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        secId: this.ID,
        startDate: this.time[0],
        endDate: this.time[1],
        sort: this.radio1,
        keywordList: this.keywordList,
        policyType: this.policyType,
        deptCode: this.organizationVal
      }

      const [err, res] = await this.$reqFn(getPolicyChain, params, 'loading')
      if (res && res.code == 200) {
        const { total, policyList } = res.data
        this.policyList = [...this.policyList, ...policyList]
        this.total = total
        this.pageNum++
      }
    },
    async resetHandle() {
      this.pageNum = 1
      this.time = getDefaultTime()
      this.keywordList = []
      this.$refs.areaDropdown.$refs.panel.clearCheckedNodes()
      this.$refs.areaDropdown.$refs.panel.activePath = []
      this.$refs.areaDropdown.$refs.panel.syncActivePath()
      await this.$nextTick()
      this.areaValue = []
      this.policyList = []

      this.organizationVal = ''
      this.policyType = []
      this.getPolicy()

      this.getPolicyStat()
    },
    searchHandle() {
      this.pageNum = 1
      this.policyList = []

      this.getCityParams()
      // 查询
      this.getPolicy()
      this.getPolicyStat()
    },
    radioHandle() {
      this.scrollKey++
      this.searchHandle()
    },
  },
}
</script>

<style scoped lang="scss">
.params-item {
  padding-bottom: 0 !important;
  & > div {
    width: 230px;
    margin-right: 16px;
    margin-bottom: 16px;
  }
}
::v-deep .el-table thead th.el-table__cell {
  background-color: #f4f6f9;
}

.textAline {
  text-align: center;
}
</style>
